export interface DefaultModalRef {
  show: () => void
  hide: () => void
}

export const ResetPasswordType = {
  FIRST_LOGIN: 'FIRST_LOGIN',
  FORCE_RESET: 'FORCE_RESET',
  MANUAL_RESET: 'MANUAL_RESET',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
}

export const SYSTEM_ROLES = {
  BANK_ADMIN: 'Bank Admin',
  CLIENT_ADMIN: 'Client Admin',
  CLIENT_USER: 'Client User',
  SYSTEM_ADMIN: 'System Admin',
}

export interface ApiResponse<T> {
  statusCode: string
  message: string
  data: T
}

export interface ApiListResponse<T> {
  data: T
  pageIndex?: number
  pageSize?: number
  total?: number
}
export interface ApiListViewResponse {
  statusCode?: string
  message?: string
  data: Data
}

export interface Data {
  items: Item[]
  total: number
}

export interface Item {
  user: string
  client: string
  accountName: string
  accountNumber: string
  username: string
  firstName: string
  lastName: string
}

export interface IOption {
  label: string
  value: any
}

export interface ICommonObject {
  [prop: string]: any
}
